const key = (contentId: string) => `edhub:cards:${contentId}`;

export function readCardIndex(contentId: string): number {
	try {
		const v = globalThis.localStorage?.getItem(key(contentId));
		const n = v == null ? 0 : Number.parseInt(v, 10);
		return Number.isFinite(n) && n >= 0 ? n : 0;
	} catch {
		return 0;
	}
}

export function writeCardIndex(contentId: string, index: number): void {
	try {
		globalThis.localStorage?.setItem(key(contentId), String(index));
	} catch {
		/* no-op: private mode / storage unavailable */
	}
}
